PF.List.Item.Dnd = class Dnd extends PF.Trait
	{
	initTrait()
		{
		this.dom.item.on('dndStart',this.start.bind(this));
		this.dom.item.on('dndDrag',this.drag.bind(this));
		this.dom.item.on('dndStop',this.stop.bind(this));
		// this.dom.item.onDnd(this.start.bind(this), this.drag.bind(this), this.stop.bind(this));
		}

	start(event)
		{
		this.hasDrug = false;

		let width = this.dom.item.width();
		let height = this.dom.item.height();

		this.list.dom.dndDummy.setHeight(this.dom.item.outerHeight(true));
		this.list.dom.dndDummy.setWidth(this.dom.item.outerWidth(true));

		this.dom.item.after(this.list.dom.dndDummy);

		this.dom.item.addClass('pf-list-drag-item');
		this.dt = event.point.top - this.dom.item.offset().top;
		this.dl = event.point.left - this.dom.item.offset().left;

		this.dom.item.css({
			top: (event.point.top - this.list.dom.ul.offset().top - this.dt)+'px',
			left: (event.point.left - this.list.dom.ul.offset().left - this.dl)+'px',
			position: 'absolute',
			width: width+'px',
			height: height+'px'
		});
		}


	drag(event)
		{
		this.dom.item.css({
			top: (event.point.top - this.list.dom.ul.offset().top - this.dt)+'px',
			left: (event.point.left - this.list.dom.ul.offset().left - this.dl)+'px',
		});
		for (let i = 0; i < this.list.length; i++)
			{
			if (this === this.list[i])
				{
				continue;
				}
			if (this.index > this.list[i].index)
				{
				if ((this.list.sortDir === 'v' && this.list[i].dom.item.offset().top + (this.list[i].dom.item.height() / 2) > event.point.top) ||
					(this.list.sortDir === 'h' && this.list[i].dom.item.offset().left + (this.list[i].dom.item.width() / 2) > event.point.left))
					{
					this.list[i].dom.item.before(this.list.dom.dndDummy);
					let index = this.list[i].index;
					this.list[i].index = this.index;
					this.index = index;
					this.model.setData(this.list.serialIndex, this.index);
					this.list[i].model.setData(this.list.serialIndex, this.list[i].index);
					break;
					}
				}
			else
				{
				if ((this.list.sortDir === 'v' && this.list[i].dom.item.offset().top + (this.list[i].dom.item.height() / 2) < event.point.top) ||
					(this.list.sortDir === 'h' && this.list[i].dom.item.offset().left + (this.list[i].dom.item.width() / 2) < event.point.left))
					{
					this.list[i].dom.item.after(this.list.dom.dndDummy);
					let index = this.list[i].index;
					this.list[i].index = this.index;
					this.index = index;
					this.model.setData(this.list.serialIndex, this.index);
					this.list[i].model.setData(this.list.serialIndex, this.list[i].index);

					break;
					}
				}
			}
		}

	stop()
		{
		this.dom.item.css({top: 0, left: 0, position: 'relative'});
		this.dom.item.removeClass('pf-list-drag-item');
		this.list.dom.dndDummy.after(this.dom.item);
		this.list.dom.dndDummy.remove();

		if (this.list.models.hasModify === true)
			{
			this.list.models.save();
			this.list.trigger('sort');
			}
		}
	};
